import { useCallback } from 'react';
import {
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { AModal } from '../../../components';
import { IFinancial } from '../../../shared/interfaces';
import api from '../../../services/api';
import { useToast } from '../../../hooks/toast';
import { Alert } from 'antd';

interface ICancelProps {
  open: boolean;
  close: () => void;
  selectRows: IFinancial[];
  setSelectRows: React.Dispatch<React.SetStateAction<IFinancial[]>>;
  setFinancials: React.Dispatch<React.SetStateAction<IFinancial[]>>;
}

const Cancel: React.FC<ICancelProps> = ({
  open,
  close,
  selectRows,
  setSelectRows,
  setFinancials,
}) => {
  const { addToast } = useToast();

  const handleEditSubmit = useCallback(async () => {
    try {
      const ids = selectRows.map((item) => String(item.id));
      const response = await api.patch(`/financials/cancel`, {
        ids,
        status: 5,
        updated_by: '',
      });

      const updatedItems = response.data;
      setFinancials((prev) =>
        prev.map((item) => {
          const updated = updatedItems.find(
            (u: IFinancial) => u.id === item.id,
          );
          return updated || item;
        }),
      );

      addToast({
        type: 'success',
        title: 'Cancelado',
        description: 'Contas canceladas com sucesso.',
      });
      setSelectRows([]);
      close();
    } catch (error: any) {
      addToast({
        type: 'error',
        title: 'Erro',
        description: error.response?.data?.message || 'Erro ao cancelar',
      });
    }
  }, [selectRows, setFinancials, addToast, close, setSelectRows]);

  return (
    <AModal
      open={open}
      close={close}
      title={
        <>
          <CloseCircleOutlined style={{ color: '#ff4d4f' }} /> Cancelar
          Lançamentos
        </>
      }
      onOk={handleEditSubmit}
      okText="Confirmar Cancelamento"
    >
      <Alert
        message="Atenção"
        description={`Você está prestes a cancelar ${selectRows.length} lançamento(s). Esta ação não poderá ser desfeita.`}
        type="warning"
        showIcon
        icon={<ExclamationCircleOutlined />}
      />
      <div style={{ marginTop: 16 }}>
        <strong>Contas selecionadas:</strong>
        <ul style={{ maxHeight: 100, overflowY: 'auto', marginTop: 8 }}>
          {selectRows.map((row) => (
            <li key={row.id}>
              {row.code} - {row.description}
            </li>
          ))}
        </ul>
      </div>
    </AModal>
  );
};

export default Cancel;
